import { render } from "./contentCreatePersonModalMobile.vue?vue&type=template&id=73ed5357"
import script from "./contentCreatePersonModalMobile.vue?vue&type=script&lang=js"
export * from "./contentCreatePersonModalMobile.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__